export default __webpack_public_path__ + "static/media/EM1450.34I-37417_-22059_0.f09723eb.jpg";